import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop error from webpack overlay (but allow console logging)
const resizeObserverErrFilter = (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    // Log to console for devs but prevent the overlay
    console.warn('ResizeObserver loop detected (benign)');
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
  return false;
};

window.addEventListener('error', resizeObserverErrFilter);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
